import ContactsBanner from './images/ContactsBanner.jpg';
import './App.css';
import { Col, Row, Button, Typography} from 'antd';
import {NavLink} from "react-router-dom";
import Header from "./Header";
import Ship from './images/ship.jpeg';

const { Title, Text } = Typography;

function Pricing() {
  return (
    <>
        <Header />
        <Row 
            style={{
                maxWidth: 1024,
                margin: '24px auto 0 auto',
                textAlign: "center"
            }}>
                <Col span={24}>
                    <Title level={1}>We turn chaos into working systems</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>
                        We help you build robust Co-Living systems, and deliver solutions that actually work. <br />Welcome to Co-Living platform that works.</Title>
                    <br />
                    <NavLink className={"menu"} to={'/contacts'}>
                        <Button 
                            size="large"
                            variant='solid'
                            color="default" 
                            style={{marginBottom: 48}}>
                                Contact sales
                        </Button>
                </NavLink>
           
                </Col>
            </Row>
            
            <Row 
            style={{
                maxWidth: 1024,
                margin: '24px auto 0 auto'
            }}>
                <Col
                    span={8}
                    style={{padding: "0 8px"}}
                >
                    <div style={{
                        borderRadius: 24,
                        backgroundColor: 'black',
                        height: "520px",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Platinum</h1>
                            <Text type='secondary' style={{display: 'block'}}>unlimited</Text>
                        </div>
                        <p style={{color: 'white', padding: 32}}>
                            <ul>
                                <li>Custom users</li>
                                <li>Custom tenant</li>
                                <li>24/7 support + Custom Support</li>
                                <li>Cloud & Multi-Cloud</li>
                                <li>AI</li>
                                <li>Workshops</li>
                                <li>Expirience manager</li>
                            </ul>
                        </p>
                        <Title level={1} style={{color: 'white', fontWeight: 300, fontSize: 56, marginTop: 0, padding: '0 32px', textAlign: 'right'}}>
                            <small style={{fontSize: 14}}>fix</small> 999€/m</Title>
                            <NavLink className={"menu"} to={'/contacts'}>
                        <Button
                            size="samll"
                            variant='solid'
                            color="default"
                            style={{margin: '28px auto 0 auto', display: 'block'}}>
                                Contact sales
                        </Button>
                        </NavLink>
                    
                     </div>
                </Col>
                <Col span={8} style={{padding: "0 8px"}}>
                    <div style={{
                        borderRadius: 24,
                        backgroundColor: 'gold',
                        height: "520px",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Gold</h1>
                            <Text type='secondary' style={{display: 'block'}}>perfect fit</Text>
                        </div>
                        <p style={{color: 'white', padding: 32}}>
                            <ul>
                                <li>25 users</li>
                                <li>3 tenant</li>
                                <li>Business hours support</li>
                                <li>Cloud</li>
                                <li>AI</li>
                            </ul>    
                            <br /><br />
                        </p>
                        <Title level={1} style={{color: 'white', fontWeight: 300, fontSize: 56, marginTop: 0, padding: '0 32px', textAlign: 'right'}}>
                            <small style={{fontSize: 14}}>fix</small> 599€/m</Title>
                            <NavLink className={"menu"} to={'/contacts'}>
                        <Button
                            size="samll"
                            variant='solid'
                            color="default"
                            style={{margin: '28px auto 0 auto', display: 'block'}}>
                                Contact sales
                        </Button>
                        </NavLink>
                    
                    </div>
                </Col>
                <Col 
                    span={8} 
                    style={{padding: "0 8px"}}
                >
                <div style={{
                        borderRadius: 24,
                        backgroundColor: 'silver',
                        height: "520px",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Silver</h1>
                            <Text type='secondary' style={{display: 'block'}}>warming up</Text>
                        </div>
                        <p style={{color: 'white', padding: 32}}>
                           <ul>
                                <li>10 users</li>
                                <li>1 tenant</li>
                                <li>Community support</li>
                            </ul>
                            <br /><br />
                            <br /><br />
                           </p>
                        <Title level={1} style={{color: 'white', fontWeight: 300, fontSize: 56, marginTop: 0, padding: '0 32px', textAlign: 'right'}}>
                            <small style={{fontSize: 14}}>fix</small> 399€/m</Title>
                            <NavLink className={"menu"} to={'/contacts'}>
                        <Button
                            size="samll"
                            variant='solid'
                            color="default"
                            style={{margin: '28px auto 0 auto', display: 'block'}}>
                                Contact sales
                        </Button>
                        </NavLink>
                        </div>
                    </Col>
            </Row>
            <br/><br/><br/>
    </>
  );
}

export default Pricing;